'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ScenarioManagementController = function ScenarioManagementController($scope, $rootScope, $compile, scenarioService, scenarioSearchCriteriaService, $log) {
  var errorTemplate = _.template(require('../templates/error-message.html'));
  $scope.scenarios = [];
  $scope.loadSearchCriteria = function (screen, date) {
    return scenarioSearchCriteriaService.buildCriteria(screen, date);
  };
  $scope.reoptStatuses = scenarioService.getReoptStatuses();
  $scope.loadScenarioList = function () {
    $scope.scenarios = scenarioService.getScenarioList();
  };
  function showErrorMessage(response, operation) {
    if (operation === 'creating') {
      response.data.fieldErrors = [{
        field: 'Contains invalid characters',
        message: '(Accepts only alphabetical characters)'
      }];
    }
    var message = errorTemplate({
      'response': response,
      'operation': operation
    });
    $log.error('ScenarioManagementController: showErrorMessage - ' + message);
    toastr.error(message);
  }
  $scope.deleteScenario = function (scenario) {
    scenarioService.deleteScenario(scenario).then(function (response) {
      $scope.deleteScenarioSuccess(response);
    }, $scope.deleteScenarioFailure);
  };
  $scope.deleteScenarioSuccess = function () {
    toastr.success('Successfully deleted scenario.');
  };
  $scope.deleteScenarioFailure = function (response) {
    showErrorMessage(response, 'deleting');
  };
  $scope.optimizeScenario = function (scenario) {
    scenarioService.optimizeScenario(scenario)["catch"](function (error) {
      optimizeScenarioFail(error);
    });
  };
  function optimizeScenarioFail(response) {
    showErrorMessage(response, $scope.reoptStatuses.optimizing);
  }
  $scope.onWindowShow = function () {
    scenarioService.updateScenarioList().then($scope.loadScenarioList);
  };
  $scope.loadScenarioList();
};
ScenarioManagementController.$inject = ['$scope', '$rootScope', '$compile', 'ScenarioService', 'ScenarioSearchCriteriaService', '$log'];
module.exports = ScenarioManagementController;